// @ts-ignore
import i18n from "@cirrus/ui-kit/src/lib/i18n.es6"
import { MuiIcon } from "@cirrus/ui-kit/src"

import { DataGridPro } from "@mui/x-data-grid-pro"
import React, { useCallback } from "react"

import { ColumnMenu, CreateRow, NoRowsOverlay } from "../components"

import {
  useColumnDefinitions,
  useColumnsCombine,
  useColumnsOrdering,
  useColumnsVisibility,
  useDataSource,
  usePagination,
  useRowHandler,
  useSelection,
  useSorting
} from "../hooks"
import { useTableContext } from "../provider"
import { Sort } from "../types"
import { useEditorCell } from "../hooks/useEditorCell"
import { useEditorRow } from "../hooks/useEditorRow"
import { StyledTable } from "./styles"
import { ProgressTableFooter } from "../components/TableFooter"

export const TableComponent = () => {


  const ctx = useTableContext()

  const hooks = {
    ...useColumnsCombine(),
    ...useSorting(),
    ...useColumnsVisibility(),
    ...usePagination(),
    ...useColumnsOrdering(),
    ...useColumnDefinitions(),
    ...useDataSource(),
    ...useRowHandler(),
    ...useSelection(),
  }

  const cellEditorHooks = useEditorCell()
  const rowEditorHooks = useEditorRow()
  const editorProps = ctx.props.editMode === "cell"
    ? cellEditorHooks.tableProps
    : rowEditorHooks.tableProps

  const onSelectionModelChange_ = hooks.onSelectionModelChange
  const onSortModelChange_ = useCallback(hooks.onSortModelChange, [ctx.data.state.sortModel])
  const onPageChanged_ = useCallback(hooks.onPageChanged, [ctx.data.state.page])
  const onPageSizeChanged_ = useCallback(hooks.onPageSizeChanged, [ctx.data.state.pageSize])
  const onColumnOrderChange_ = useCallback(hooks.onColumnOrderChange, [ctx.columns.state.columnDefinitions])
  const onRowClick_ = useCallback(hooks.onRowClick, [ctx.props.rowClickHandler])

  return (

    <StyledTable

      checkboxSelection={ctx.props.enableCheckboxSelection}
      pagination={ctx.props.enablePagination}
      disableColumnMenu={!ctx.props.enableColumnMenu}

      apiRef={ctx.muiGridApiRef}

      columns={ctx.columns.state.columnDefinitions}
      rows={ctx.props.rows}
      rowCount={ctx.props.total}

      // Selection & row-handling
      disableSelectionOnClick={ctx.props.disableSelectionOnClick}
      isRowSelectable={ctx.props.isRowSelectable}
      onSelectionModelChange={onSelectionModelChange_}
      onRowClick={onRowClick_}

      // Layout & styling
      density={ctx.props.density ?? "standard"}
      autoHeight={false}
      disableColumnResize={true}
      getRowClassName={ctx.props.getRowClassName}

      // Sorting
      sortModel={ctx.data.state.sortModel}
      sortingOrder={[Sort.asc, Sort.desc]}
      onSortModelChange={onSortModelChange_}

      // Pagination
      rowsPerPageOptions={ctx.props.rowsPerPageOptions}
      onPageChange={onPageChanged_}
      onPageSizeChange={onPageSizeChanged_}

      onColumnOrderChange={onColumnOrderChange_}

      // Performance
      paginationMode={"server"}
      sortingMode={ctx.props.sortingMode || "server"}
      scrollEndThreshold={0}
      // throttleRowsMs={100}

      columnVisibilityModel={ctx.columns.state.visibility}

      defaultGroupingExpansionDepth={0}
      components={{
        ColumnMenu: () => null,
        ColumnMenuIcon: () => null,
        ColumnSortedAscendingIcon: () => <MuiIcon.ArrowDropUp />,
        ColumnSortedDescendingIcon: () => <MuiIcon.ArrowDropDown />,
        NoResultsOverlay: () => <NoRowsOverlay />,
        NoRowsOverlay: () => <NoRowsOverlay />,
        Row: CreateRow(),
        Pagination: () => <ProgressTableFooter />
      }}
      componentsProps={{
        pagination: {
          labelDisplayedRows: ({ count, from, to }) =>
            `${from} - ${to} ` + i18n("General:Of") + ` ${count}`,
          labelRowsPerPage: i18n("General:RowsPerPage"),
        },
      }}
      localeText={{
        footerRowSelected: (count) =>
          `${count} ` +
          (count === 1
            ? i18n("General:RowSelected")
            : i18n("General:RowsSelected")),
      }}
      // treeData={ctx.props.treeData}
      // getTreeDataPath={ctx.props.getTreeDataPath}
      // groupingColDef={ctx.props.groupingColDef}

      editMode={ctx.props.editMode}
      {...editorProps}
    />
  )
}
